const API_BASE = 'https://ux97q9k5kb.execute-api.us-east-2.amazonaws.com/prod';

function authHeaders() {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

async function parseJson(response) {
  const data = await response.json();
  return typeof data === 'string' ? JSON.parse(data) : data;
}

export async function fetchWeekPicks(weekNum, season) {
  const response = await fetch(`${API_BASE}/picks/week/${weekNum}?season=${season}`);
  if (!response.ok) {
    throw new Error('Failed to fetch picks');
  }
  return parseJson(response);
}

export async function fetchUserPicks(userId, season) {
  const response = await fetch(`${API_BASE}/picks/${userId}?season=${season}`);
  if (!response.ok) {
    throw new Error('Failed to fetch user picks');
  }
  return parseJson(response);
}

export async function submitPick({ weekNum, pick, odds, season }) {
  return fetch(`${API_BASE}/picks`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify({ weekNum, pick, odds, season }),
  });
}

export async function updatePickResult({ userId, weekNum, result, season }) {
  return fetch(`${API_BASE}/picks/result`, {
    method: 'PATCH',
    headers: authHeaders(),
    body: JSON.stringify({ userId, weekNum, result, season }),
  });
}
